import React, { createContext, useState, useContext } from "react";

// Create context
const LoadingContext = createContext();

// Custom hook for easy access
export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
      throw new Error("useLoading must be used within a LoadingProvider");
    }
    return context;
  };

// Provider component
export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
  
    return (
      <LoadingContext.Provider value={{ loading, setLoading }}>
        {children}
      </LoadingContext.Provider>
    );
  };